import {TableList} from "../../../../partials/Table";
import {FormattedMessage} from "react-intl";
import {sortCaret} from "../../../../../../_metronic/_helpers";
import React from "react";
import * as columnFormatters from "../../../../CrudFormPage/table/column-formatters";
import {SupervisorName} from "./SupervisorName";

export const GroupTable = () => <TableList columns={[
    {
        dataField: 'id',
        text: <FormattedMessage
            id="PTBP.COMMON.ID"
            defaultMessage="Id"
        />,
        sort: true,
        sortCaret
    },
    {
        dataField: 'name',
        text: <FormattedMessage
            id="PTBP.GROUP.NAME"
            defaultMessage="Nome"
        />,
        sort: true,
        sortCaret
    },
    {
        dataField: 'supervisor',
        text: <FormattedMessage
            id="PTBP.GROUP.SUPERVISOR"
            defaultMessage="Supervisore"
        />,
        sort: true,
        sortCaret,
        formatter: (row) => {
            return <SupervisorName id={row}/>
        }
    },
    {
        dataField: "action",
        text: <FormattedMessage id="PTBP.PRODUCTS_PAGE.TABLE.COLUMNS.ACTIONS"/>,
        formatter: columnFormatters.ActionsColumnFormatter,
        classes: "text-right pr-0",
        headerClasses: "text-right pr-3",
        style: {
            minWidth: "100px",
        },
    },
]}/>
